import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

import { supabase } from '@/lib/auth/client'
import { useCopy } from '@/lib/copy/use-copy'

type Status = 'pending' | 'error'

export const Route = createFileRoute('/auth/callback')({
  component: () => {
    const navigate = useNavigate()
    const copy = useCopy().shell.auth
    const [status, setStatus] = useState<Status>('pending')

    useEffect(() => {
      const url = new URL(window.location.href)
      const code = url.searchParams.get('code')
      if (!code) {
        setStatus('error')
        return
      }
      supabase.auth.exchangeCodeForSession(code).then(({ data, error }) => {
        if (error || !data.session) {
          setStatus('error')
          return
        }
        navigate({ to: '/today' })
      })
    }, [navigate])

    if (status === 'error') {
      return (
        <section className="space-y-3 p-6">
          <p className="text-sm text-red-300">{copy.errorGeneric}</p>
          <Link className="text-sm underline" to="/login">{copy.titleLine1}</Link>
        </section>
      )
    }
    return <p className="p-6">Logowanie...</p>
  },
})
